import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyleSheet } from 'hoc/styles';
import { Autocomplete } from 'components/Autocomplete';
import { styleSheet } from './stylesheet';

class NewsSourceAutocomplete extends PureComponent {
    static propTypes = {
        passedStyles: PropTypes.objectOf(PropTypes.any),
        styles: PropTypes.objectOf(PropTypes.any).isRequired,
        options: PropTypes.arrayOf(PropTypes.object).isRequired,
        initialSearchTerm: PropTypes.string,
        label: PropTypes.string,
        loading: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        placeholder: PropTypes.string.isRequired,
        value: PropTypes.string
    };

    static defaultProps = {
        passedStyles: {},
        initialSearchTerm: null,
        label: null,
        value: null
    };

    render() {
        const {
            initialSearchTerm,
            label,
            loading,
            name,
            onChange,
            options,
            passedStyles,
            placeholder,
            styles,
            value
        } = this.props;
        return (
            <Autocomplete
                initialSearchTerm={initialSearchTerm}
                label={label}
                loading={loading}
                name={name}
                onChange={onChange}
                options={options}
                placeholder={placeholder}
                styles={{ ...styles.container, ...passedStyles }}
                value={value}
            />
        );
    }
}

export const NewsSourceAutocompleteUI = compose(withStyleSheet(styleSheet))(NewsSourceAutocomplete);
